import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo UserController (api/user) + UserSecurityController (api/user-security).
// Users are ZiiCloud identities: POST is an invitation by email, DELETE only stops the merchant link.
const enc = encodeURIComponent;

const list = () => Client.get('/api/user');
const queryPager = (query) =>
	Client.post('/api/user/query-pager', { ...PAGE_ALL, ...(query || {}) }).then(
		pagerRows
	);
const get = (userCode) => Client.get(`/api/user/${enc(userCode)}`);

// Settings list = GET api/user (UserRepository.ListAllBrief: every merchant user, StopFlag taken from
// gy_merchant_user) filtered to From ∈ {SCM, Zii} like ListPageBrief. The paged query drops deleted
// users (gy_merchant_user.StopFlag = 0); the list keeps them so the "Deleted" column means something
// and a deleted user can be reopened and restored.
const listForSettings = async () => {
	const all = await list();
	return (all || []).filter((u) => [0, 1].includes(Number(u.from)));
};
const invite = (dto) => Client.post('/api/user', dto);
const update = (userCode, dto) => Client.put(`/api/user/${enc(userCode)}`, dto);
const remove = (userCode) => Client.del(`/api/user/${enc(userCode)}`);
// ChangeUserAvatarReq { userCode, avatarUrl } (null clears the avatar)
const updateImage = (userCode, avatarUrl) =>
	Client.put(`/api/user/image/${enc(userCode)}`, { userCode, avatarUrl });

// Companies a user may work in (UserDepartment). Save = full replace.
const depts = (userCode) =>
	Client.get(`/api/user-security/dept/${enc(userCode)}`).then(pagerRows);
const saveDepts = (userCode, deptCodes) =>
	Client.put(`/api/user-security/dept/${enc(userCode)}`, {
		recordList: (deptCodes || []).map((deptCode) => ({ userCode, deptCode })),
	});

// Roles of a user (all companies). Save replaces only the roles of the given company.
const roles = (userCode) =>
	Client.get(`/api/user-security/role/${enc(userCode)}`).then(pagerRows);
const saveRoles = (userCode, deptCode, roleCodes) =>
	Client.put(`/api/user-security/role/${enc(userCode)}`, {
		userCode,
		deptCode: deptCode || '',
		roleCodes: roleCodes || [],
	});

// { permissionCode, url, deptCode, userCode? } → bool (komodo PageBase.IsAuthorizated)
const functionVerify = (request) =>
	Client.post('/api/user-security/function-verify', request);
const syncFromZii = () => Client.get('/api/user-security/sync-from-zii');

export default {
	updateImage,
	list,
	queryPager,
	listForSettings,
	get,
	invite,
	update,
	remove,
	depts,
	saveDepts,
	roles,
	saveRoles,
	functionVerify,
	syncFromZii,
};
